var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoundedNumber3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2093 13.3268C18.766 13.5296 19.9537 14.0873 20.7722 15C21.5907 15.9127 22 17.0535 22 18.4225C22 19.4535 21.7512 20.3915 21.2537 21.2366C20.7562 22.0817 20.0019 22.7577 18.9907 23.2648C17.9957 23.7549 16.7759 24 15.3315 24C14.1278 24 12.9642 23.8225 11.8407 23.4676C10.7333 23.0958 9.78642 22.5887 9 21.9465L10.3481 19.3859C10.958 19.9268 11.6963 20.3577 12.563 20.6789C13.4457 20.9831 14.3525 21.1352 15.2833 21.1352C16.3907 21.1352 17.2574 20.8986 17.8833 20.4254C18.5253 19.9352 18.8463 19.2761 18.8463 18.4479C18.8463 17.6197 18.5414 16.9775 17.9315 16.5211C17.3377 16.0479 16.4228 15.8113 15.187 15.8113H13.6463V13.5549L17.4741 8.76338H9.81852V6H21.3019V8.20563L17.2093 13.3268Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundedNumber3);
export default __webpack_public_path__ + "static/media/rounded-number-3.b67d03577709b69ea6f3b5a69d586b42.svg";
export { ForwardRef as ReactComponent };